import { FirestoreQueryBuilder } from 'gcp/builder/firestore-query.builder';
import { IRepository } from '../../../../utility/repository/repository';
import { KnowledgeActivity } from '../entity';
import { KnowledgeActivityId } from '../value';
import { Observable } from 'rxjs';

export abstract class IKnowledgeActivityRepository extends IRepository<KnowledgeActivityId, KnowledgeActivity> {
  abstract selectAll(builder: FirestoreQueryBuilder<KnowledgeActivity>): Observable<KnowledgeActivity>;
}
